<script>
export default {
  name: 'SelectionPlaceholder',
  computed: {
    placeholderWidth() {
      const randomNum = this.getRandomInt({ min: 10, max: 100 });
      return `width:${randomNum}%`;
    },
  },
  methods: {
    getRandomInt({ min, max }) {
      const minNum = Math.ceil(min);
      const maxNum = Math.floor(max);
      return Math.floor(Math.random() * (maxNum - minNum + 1)) + minNum;
    },
  },
};
</script>
<template>
  <div class="selection-placeholder-wrap">
    <div class="selection-placeholder__silk"></div>
    <div :style="placeholderWidth" class="selection-placeholder__main"></div>
  </div>
</template>
